import { submitAstuteCredentials } from './Effects/astuteCredentials'

export const NAVIGATE_TO_INDEX = 'NAVIGATE_TO_SHOW'
export const NAVIGATE_TO_FORM = 'NAVIGATE_TO_FORM'

export const createActions = (dispatch, state) => ({
  navigateToIndex: () => {
    dispatch({ type: NAVIGATE_TO_INDEX })
  },
  navigateToForm: () => {
    dispatch({
      type: NAVIGATE_TO_FORM,
    })
  },
  submitAstuteCredentialsForm: async (values, setFormSubmitting) => {
    await submitAstuteCredentials(
      state,
      {
        username: values.username,
        password: values.password,
      },
      setFormSubmitting
    )
    dispatch({ type: NAVIGATE_TO_INDEX })
  },
})
